import React from 'react';
import Footer from "./modules/views/Footer";
import AppAppBar from "./modules/views/AppAppBar";
import Vacancies from "./modules/views/Vacancies";

function VacanciesPage() {
  return (
    <React.Fragment>
      <AppAppBar />
      <Vacancies />
      <Footer />
    </React.Fragment>
  );
}

export default VacanciesPage;
